import { ParsedUrlQuery } from "querystring";

/*
    CU = Close Up
    WS = Wide Shot
    SH = Sheet
    RB = Roman Blind
    PP = Pencil Pleat
    DP = Double Pleat
    TP = Triple Pleat
    EL = Eyelet
*/

export const filterM2MImages = (
  images: { primary: string; alternatives: string[] },
  query: ParsedUrlQuery,
) => {
  const isRomanBlind = query?.roman === "true";
  const filterGroup = isRomanBlind
    ? ["CURB", "SHRB"]
    : ["WSPP", "WSDP", "WSTP", "WSEL", "CUPP", "CUDP", "CUTP", "CUEL"];

  const filteredAlternativeImages =
    images.alternatives.filter((url) =>
      filterGroup.some((suffix) => url.endsWith(suffix)),
    ) || [];

  if (!filteredAlternativeImages.length) return images;

  let primary = images.primary;

  if (isRomanBlind) {
    // make the Wide Shot Roman Blind the primary image
    primary =
      images.alternatives.find((url) => url.endsWith("WSRB")) || images.primary;
    // add the original primary image to the alternatives
    filteredAlternativeImages.push(images.primary);
  }

  return { ...images, primary, alternatives: filteredAlternativeImages };
};
